export const PLAN_FEATURE_CONFIG = [
  { key: 'advanceSearch', label: 'Advanced Search' },
  { key: 'limitedSupport', label: 'Limited Support' },
  { key: 'limitedChat', label: 'Limited Chat' },
  { key: 'highlightedProfile', label: 'Highlighted Profile' },
  { key: 'astroMatchmaking', label: 'Astro Matchmaking' },
  { key: 'dedicatedManager', label: 'Dedicated Manager' },
  { key: 'dedicatedSeniorManager', label: 'Senior Manager' },
  { key: 'arrangedMeetings', label: 'Arranged Meetings' },
  { key: 'hideProfile', label: 'Hide Profile' },
] as const;

export type PlanFeatureKey = (typeof PLAN_FEATURE_CONFIG)[number]['key'];
